module.exports = __webpack_public_path__ + "img/34.a581145a.png";